import { NavLink } from 'react-router-dom'

// styles and images 
import './Admin.css'
import Companies from '../../assets/companies.svg'
import AdminUsers from '../../assets/admin-users.svg'

// globla
import { userStore } from '../../store/Store'


export default function AdminSidebar() {
    // global
    const currentUser = userStore(userDataStore => userDataStore.currentUser )
    const currentCompany = userStore(userDataStore => userDataStore.currentCompany)
    const JwtToken = userStore(userDataStore => userDataStore.JwtToken)

    return (currentUser && currentCompany && JwtToken) &&(
        <div className='admin-sidebar'>
            <div className='admin-sidebar-content'>
                <nav className='links'>
                    <ul>
                        <li>
                            <NavLink to='/admin/companies' end>
                                <img src={Companies} 
                                alt="companies" 
                                />
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to='/admin/admin-users' end>
                                <img src={AdminUsers}
                                alt="admin-users"
                                />
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}
